import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Elo = ({ size, className, id }) => {
  let ratio = size / 100;

  let width = size,
    height = 63 * ratio;

  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };

  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }

  return (
    <svg {..._attributes}>
      <g transform="translate(-929 -624)">
        <rect width="100" height="63" transform="translate(929 624)" fill="none" />
        <g transform="translate(958.578 635.268)">
          <g transform="translate(0)">
            <path d="M151.707,222.283a20.423,20.423,0,1,1-20.423,20.423,20.423,20.423,0,0,1,20.423-20.423Z" transform="translate(-131.284 -222.283)" fill="#050013" stroke="#231f20" strokeMiterlimit="22.926" strokeWidth="0.567" fillRule="evenodd" />
            <path id="Caminho_1162" data-name="Caminho 1162" d="M183.42,349.913a6.278,6.278,0,0,1,6.1,4.8l-2.53,1.106v-.005l-2.588,1.137-6.208,2.714a6.277,6.277,0,0,1,5.225-9.754Zm2.694,3.9-6.269,2.7c-.01-.108-.015-.217-.015-.328a3.591,3.591,0,0,1,6.285-2.374Z" transform="translate(-171.772 -334.963)" fill="#fff" fillRule="evenodd" />
            <path id="Caminho_1163" data-name="Caminho 1163" d="M209.133,427.346a6.224,6.224,0,0,1-7.832.756l1.476-2.244a3.667,3.667,0,0,0,4.48-.433l1.877,1.921Z" transform="translate(-193.1 -401.631)" fill="#fff" fillRule="evenodd" />
            <path id="Caminho_1164" data-name="Caminho 1164" d="M289.865,339.1l-.016-11.869H292.1v11.548a.236.236,0,0,0,.159.265l1.956.761-.881,2.292-2.291-.97c-.869-.368-1.174-.9-1.175-2.027Z" transform="translate(-271.276 -314.941)" fill="#fff" fillRule="evenodd" />
          </g>
          <g transform="translate(22.937 14.819)">
            <path d="M331.223,368.22a3.579,3.579,0,0,1-.269-5.426l-1.452-2.354a6.313,6.313,0,0,0,.35,10.161Z" transform="translate(-327.104 -359.077)" fill="#009dd7" fillRule="evenodd" />
            <path d="M361.915,351.741a3.584,3.584,0,0,1,4.564,2.109l2.783-.233a6.315,6.315,0,0,0-8.509-4.357Z" transform="translate(-356.812 -348.797)" fill="#fff200" fillRule="evenodd" />
            <path d="M369.792,404.191a3.583,3.583,0,0,1-4.45,3.3l-1.092,2.528a6.314,6.314,0,0,0,8.272-5.742Z" transform="translate(-359.9 -397.703)" fill="#e33206" fillRule="evenodd" />
          </g>
        </g>
      </g>
    </svg>
  );
};

Elo.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Elo.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
